import { FunctionComponent, useCallback } from 'react'
import { useLogin } from '@dxp-module/login'
import { SignupFormSchema } from '../../model/SignupForm'
import Signup from './Signup'

export type SignupClassesType = {
  root?: string
  cardContent?: string
  paper?: string
}

type SignupContainerProps = {
  classes?: SignupClassesType
}

const SignupContainer: FunctionComponent<SignupContainerProps> = ({
  classes,
}) => {
  const { login, loading } = useLogin()

  const handleRegisterSuccess = useCallback(
    (_?: boolean | undefined, formData?: SignupFormSchema) => {
      if (!loading && formData) {
        login(formData.nameInfo.uniqueUserEmail, formData.nameInfo.password)
      }
    },
    [login, loading]
  )

  return <Signup classes={classes} onRegisterSuccess={handleRegisterSuccess} />
}

export default SignupContainer
